import React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  TextInput,
  SelectInput,
  DateTimeInput,
  BooleanInput,
  NumberInput,
  required,
  ReferenceInput,
} from 'react-admin';

const challengeTypeChoices = [
  { id: 'quit_smoking', name: 'Бросить курить' },
  { id: 'quit_porn', name: 'Бросить порно' },
  { id: 'quit_sugar', name: 'Бросить сахар' },
  { id: 'quit_alcohol', name: 'Бросить алкоголь' },
  { id: 'exercise', name: 'Упражнения' },
  { id: 'meditation', name: 'Медитация' },
  { id: 'reading', name: 'Чтение' },
  { id: 'water_drinking', name: 'Пить воду' },
  { id: 'sleep_schedule', name: 'Режим сна' },
  { id: 'no_social_media', name: 'Без соцсетей' },
  { id: 'custom', name: 'Кастомный' },
];

const challengeStatusChoices = [
  { id: 'active', name: 'Активный' },
  { id: 'paused', name: 'Приостановлен' },
  { id: 'completed', name: 'Завершен' },
  { id: 'failed', name: 'Провален' },
];

const challengeModeChoices = [
  { id: 'personal', name: 'Личный' },
  { id: 'group', name: 'Групповой' },
];

export const ChallengeCreate = () => (
  <Create>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput source="title" validate={[required()]} label="Название" />
        <TextInput source="description" multiline rows={4} label="Описание" />
        <SelectInput 
          source="type" 
          choices={challengeTypeChoices} 
          validate={[required()]} 
          label="Тип"
          defaultValue="custom" 
        />
        <SelectInput 
          source="status" 
          choices={challengeStatusChoices} 
          validate={[required()]} 
          label="Статус"
          defaultValue="active" 
        />
        <SelectInput 
          source="mode" 
          choices={challengeModeChoices} 
          validate={[required()]} 
          label="Режим"
          defaultValue="personal" 
        />
        
        <DateTimeInput source="startDate" validate={[required()]} label="Дата начала" />
        <DateTimeInput source="endDate" label="Дата окончания" />
        
        <BooleanInput source="isPublic" label="Публичный" defaultValue={true} />
        <NumberInput source="maxParticipants" label="Максимум участников" />
      </FormTab>

      <FormTab label="Автор">
        <ReferenceInput source="userId" reference="users" label="Автор">
          <SelectInput optionText="name" validate={[required()]} />
        </ReferenceInput>
      </FormTab>

      <FormTab label="Начальная статистика">
        <NumberInput source="currentStreak" label="Текущая серия" defaultValue={0} />
        <NumberInput source="bestStreak" label="Лучшая серия" defaultValue={0} />
        <NumberInput source="totalDays" label="Всего дней" defaultValue={0} />
      </FormTab>

      <FormTab label="Стейкинг">
        <BooleanInput source="isStaked" label="Включен стейкинг" defaultValue={false} />
        <BooleanInput source="stakingCompleted" label="Стейкинг завершен" defaultValue={false} />
        <TextInput source="stakedAmount" label="Сумма стейка" />
        <TextInput source="stakingTokenAddress" label="Адрес токена" />
        <TextInput source="stakingTransactionHash" label="Хеш транзакции" />
      </FormTab>
    </TabbedForm>
  </Create>
);
